// Shared per-user volatility amplifier for ALL market feeds (crypto + forex + all pairs).
// Amplifies each tick's deviation from a slow EMA baseline so price swings grow with
// the factor while staying mean-reverting (no runaway drift).
let _f = 1;
const _ema = {};

export function setVolatilityFactor(v) { _f = (v && v > 0) ? Number(v) : 1; }
export function getVolatilityFactor() { return _f; }

export function amplify(symbol, price) {
  if (!Number.isFinite(price)) return price;
  const prev = _ema[symbol];
  const a = 0.05; // slow baseline smoothing
  const ema = prev == null ? price : prev + a * (price - prev);
  _ema[symbol] = ema;
  if (_f === 1) return price;
  return ema + (price - ema) * _f;
}
